export const Input = {
  baseStyle: {
    fontWeight: "bold",
    textTransform: "uppercase",
    letterSpacing: "0",
    borderRadius: "10px",
  },
  variants: {
    filled: {
      bg: "#f6f6f6",
    },
    primary: {
      bg: "dark.50",
      fontSize: ["xs", "sm", "md"],
    },
  },
  sizes: {},

  defaultProps: {
    variant: "primary",
    size: "lg",
  },
}
